import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Why-choose-us.css';

export function WhyChooseUs() {
    const { language } = useLanguage();
    const isRtl = language === 'ar';

    const stats = [
        { id: 1, val: '+100', label: isRtl ? 'مشروع مكتمل' : 'Projects', color: '#c8a84b' },
        { id: 2, val: '+90', label: isRtl ? 'عميل راضٍ' : 'Clients', color: '#e63946' },
        { id: 3, val: '+7', label: isRtl ? 'سنوات خبرة' : 'Years Exp', color: '#e63946' },
        { id: 4, val: '24/7', label: isRtl ? 'دعم فني' : 'Support', color: '#c8a84b' }
    ];

    return (
        <section className="ultra-section" dir={isRtl ? 'rtl' : 'ltr'}>
            <div className="ultra-watermark">{isRtl ? 'إرث' : 'LEGACY'}</div>
            
            <div className="ultra-container">
                <div className="ultra-main">
                    <div className="ultra-badge">
                        <span className="u-line"></span>
                        <span className="u-tag">{isRtl ? 'لماذا نحن' : 'WHY US'}</span>
                    </div>
                    
                    <h2 className="ultra-title">
                        {isRtl ? (
                            <>نحن لا نبني جدراناً، <span className="gold-txt">بل نصنع إرثاً</span></>
                        ) : (
                            <>We Don’t Just Build, <span className="gold-txt">We Create Legacies</span></>
                        )}
                    </h2>
                    
                    <p className="ultra-desc">
                        {isRtl 
                          ? 'منذ 7 سنوات، تلتزم أيونك بتحويل الرؤى المعمارية إلى حقائق ملموسة تتسم بالفخامة والدقة المتناهية.' 
                          : 'For 7 years, Ayonk has been committed to turning architectural visions into luxurious, precise realities.'}
                    </p>

                    <div className="ultra-stats">
                        {stats.map(stat => (
                            <div key={stat.id} className="u-stat-box">
                                <span className="u-num" style={{ color: stat.color }}>{stat.val}</span>
                                <span className="u-lab">{stat.label}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="ultra-side-box">
                    <div className="u-box-content">
                        <h4 className="u-box-title">{isRtl ? 'نقاط القوة' : 'Core Strengths'}</h4>
                        <ul className="u-list">
                            <li><span className="u-dot"></span> {isRtl ? 'إدارة جودة معتمدة' : 'Quality Management'}</li>
                            <li><span className="u-dot"></span> {isRtl ? 'فريق خبير محترف' : 'Professional Team'}</li>
                            <li><span className="u-dot"></span> {isRtl ? 'تسليم دقيق بالمواعيد' : 'Punctual Delivery'}</li>
                            <li><span className="u-dot"></span> {isRtl ? 'أسعار تنافسية مدروسة' : 'Competitive Pricing'}</li>
                            <li><span className="u-dot"></span> {isRtl ? 'تقنيات بناء حديثة' : 'Modern Techniques'}</li>
                        </ul>
                        <div className="u-box-footer">
                            <p>{isRtl ? 'الجودة هي معيارنا الوحيد' : 'Quality is our only standard'}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
